export const TagPaths = {
  DATA_ENABLED_TAGS: (caseId: string, tagId: string): string => `/twiageCases/${caseId}/tags/${tagId}/values`,
};
